const FileLink = {
  props: [
    {
      name: 'data-source',
      default: '',
      type: 'any[]',
      desc: '数据源'
    },
    {
      name: 'props',
      default: '{ name: "name", url: "url"}',
      type: 'any[]',
      desc: '数据配置项'
    },
    {
      name: 'type',
      default: 'primary',
      type: 'primary | success | warning | danger | info',
      desc: '风格'
    },
    {
      name: 'download-fn',
      default: '',
      type: '() => Promise<any>',
      desc: '批量下载钩子'
    }
  ]
}

export default [
  {
    name: 'FileLink API',
    content: FileLink
  }
]
